module.exports = __webpack_public_path__ + "img/list.a7f8be6a.svg";